export enum EEventsLabels {
    GO_TO_SITE_CLICK = 'Go_to_site_click',
    SOMETHING_NOT_WORKING_CLICK = 'Something_not_working_click',
    IT_CLICK = 'IT_click',
    NON_IT_CLICK = 'Non_IT_click',
    IT_OPERATIONAL_WORKFORCE_CLICK = 'IT_operational_workforce_click',
    MANAGED_IT_SERVICES_CLICK = 'Managed_IT_services_click',
    NON_IT_OPERATIONAL_WORKFORCE_CLICK = 'Non_IT_operational_workforce_click',
    STRATEGIC_CONSULTING_CLICK = 'Strategic_consulting_click',
    DELIVERABLE_BASED_SERVICES_CLICK = 'Deliverable_based_services_click',
    OUTSOURCED_SERVICES_CLICK = 'Outsourced_services_click',
    SUBMIT_FORM_CLICK = 'Submit_form_click',
    FILTERS_CLICK = 'Filters_click',
    FILTERS_VALUE_CHANGE = 'Filters_value_change',
    OPEN_REQUEST_TAB_CLICK = 'Open_request_tab_click',
    CLOSED_REQUEST_TAB_CLICK = 'Closed_request_tab_click',
    DRAFT_TAB_CLICK = 'Draft_tab_click',
    LIST_DECLINE_CLICK = 'List_decline_click',
    LIST_APPROVE_CLICK = 'List_approve_click',
    EXPAND_CLICK = 'Expand_click',
    DECLINE_CLICK = 'Decline_click',
    APPROVE_CLICK = 'Approve_click',
    REQUEST_DESCRIPTION_TAB_CLICK = 'Request_description_tab_click',
    REQUEST_DETAILS_TAB_CLICK = 'Request_details_tab_click',
    RESOURCE_DETAILS_TAB_CLICK = 'Resource_details_tab_click',
    REVIEW_TAB_CLICK = 'Review_tab_click',
    ATTACHMENTS_TAB_CLICK = 'Attachments_tab_click',
    REQUEST_ACTIVITY_CLICK = 'Request_activity_click',
    UPDATE_PROJECT_OWNER_CLICK = 'Update_project_owner_click',
    SAVE_PROJECT_OWNER_CLICK = 'Save_project_owner_click',
    DOWNLOAD_ATTACHMENTS_CLICK = 'Download_attachments_click',
    SEARCH_INPUT_CHANGE = 'Search_input_change',
    PROJECT_OWNER_INPUT_CHANGE = 'Project_owner_input_change',
}
